<template>
  <button
    :class="{ 'is-added': addedState }"
    @click="clickHandler()"
    class="btn-link-alt"
    v-b-tooltip
    :title="tooltipText"
  >
    <svg-icon v-if="addedState" icon="eye-close" />
    <svg-icon v-else icon="eye" />
    <span v-if="!small">{{ title }}</span>
  </button>
</template>

<script>
export default {
  props: {
    added: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      addTitle: this.$t('addToWatchList'),
      removeTitle: this.$t('removeFromWatchList'),
      addedState: this.added
    };
  },

  computed: {
    title() {
      return this.addedState ? this.removeTitle : this.addTitle;
    },

    tooltipText() {
      return this.small ? this.title : '';
    }
  },

  methods: {
    clickHandler() {
      this.addedState = !this.addedState;
    }
  }
};
</script>
